import React from "react";
import "./Loader.css";
const Loader = () => {
  return (
    <div className="flex center w-full">
      <div className="loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
